import React from 'react';
import notFound from '../../assets/NotFound.jpg';

const NotFound = () => {
    return (
        <div className='flex min-h-screen items-center justify-center'>
            <img className='w-1/2' src={notFound} alt="" />
        </div>
    );
};

export default NotFound;